import styles from "./headline.module.css";
// import ImgBuilder from "../../assets/HeadlineBuilder"; // artifcat
import ImgBuilder from "../../assets/ImgBuilder";


const Headline = ({ msg, idx }) => {
  return (
    <div key={idx} className={styles.messageRow}>
      <div className={styles.message}>
        <img src={ImgBuilder[msg.asset]} alt='headline' className={styles.headlinePicture} />
        <p className={styles.headlineText}>{msg.text}</p>
      </div>
    </div>
  );
};
export default Headline;

